import { render, staticRenderFns } from "./accountDetailManageList.vue?vue&type=template&id=a5a31794&scoped=true"
import script from "./accountDetailManageList.vue?vue&type=script&lang=js"
export * from "./accountDetailManageList.vue?vue&type=script&lang=js"
import style0 from "./accountDetailManageList.vue?vue&type=style&index=0&id=a5a31794&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5a31794",
  null
  
)

export default component.exports